import uid from 'uuid/v1';

export default uid;
